const GeneralConfig = {
  homepage: 'https://pilarintan.com',
  apiHostname: 'https://api.pilarintan.com',
  hostname: 'https://pilarintan.com',
  assetsHostname: 'https://api.pilarintan.com',
  dateFormat: 'DD/MM/YYYY',
};

export default GeneralConfig;
